import { render, staticRenderFns } from "./currencies.vue?vue&type=template&id=7d8a7306&"
import script from "./currencies.vue?vue&type=script&lang=ts&"
export * from "./currencies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports